import { morphSection } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * 最近浏览。
 *
 * 和主题自带的 product-recommendations 同一套路数：空壳先上，客户端拿到 id 后
 * 用 Section Rendering API 取回整段再 morph 进来。
 *
 * 🔴 为什么必须 morph 整段、不能只注入商品卡：
 *   轮播是 <slideshow-component> 自定义元素 + resource-list-carousel 的 {% stylesheet %}，
 *   只塞卡片的话既没有轮播骨架、section 样式也可能没被打进全局包。
 *   morphSection 的 injectStylesheet 就是为这个场景准备的。
 */
class InsmiaRecentlyViewed extends HTMLElement {
  #started = false;

  connectedCallback() {
    // data-loaded 由 Liquid 在「带数据那次渲染」上打，morph 回来后不会再跑一遍
    if (this.#started || this.dataset.loaded === 'true') return;
    this.#started = true;
    this.#load();
  }

  async #load() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const limit = Number(this.dataset.limit) || 4;
    const exclude = this.dataset.exclude || '';
    const ids = RecentlyViewed.getProducts()
      .map(String)
      .filter((id) => id && id !== exclude)
      .slice(0, limit);

    if (ids.length === 0) return; // 没有历史就一直保持隐藏

    const searchUrl = globalThis.Theme?.routes?.search_url || '/search';
    const url = new URL(searchUrl, location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url);
      if (!response.ok) return;

      const html = await response.text();
      if (!html.trim()) return;

      // 🔴 必须用 'full'，不能抄推荐位的 'hydration'：
      // hydration 模式只 morph 带 data-hydration-key 的子树（见 assets/morph.js 的
      // morphHydrationByKey），推荐位根节点上有那个属性，我们这个空壳没有 ⇒
      // 用 hydration 会「不报错但什么都不换」，排查时极易误判成 fetch 失败。
      await morphSection(sectionId, html, { mode: 'full', injectStylesheet: true });
    } catch (error) {
      // 取数失败就保持隐藏。这一栏是锦上添花，不允许影响页面其它部分。
    }
  }
}

if (!customElements.get('insmia-recently-viewed')) {
  customElements.define('insmia-recently-viewed', InsmiaRecentlyViewed);
}
